import styled from 'styled-components';
import { colors, wrapper } from 'globalStyles';

export const Wrapper = styled.div`
  padding-bottom: 3em;
`;

export const ButtonWrapper = styled.div`
  button {
    padding: 0.8em 40px;
  }
`;

export const Title = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
`;

export const HeaderFilter = styled.div`
  align-items: center;
  display: flex;
`;

export const StyledEmptyList = styled.div`
  text-align: center;
  color: rgba(104,129,144,0.6);

  > svg {
    fill: ${colors.GRAY};
  }
  >a {
    > button {
      font-size: 12px;
    }
  }
`;

export const EmptyText = styled.p`
  padding-bottom: 40px;
`;

export const FilterButton = styled.div`
  height: 28px;
  width: 75px;
  padding: 0 5px 0 10px;
  margin-left: 30px;
  border: 1px solid ${colors.LIGHTER_GRAY}
  background-color: ${colors.LIGHTEST_GRAY}
  color: ${colors.DARK};
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 2px;
  line-height: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const FilterContent = styled.div`
  z-index: 1;
  position: relative;
  > div {
    position: absolute;
    top: 2px;
    left: 30px;
    box-shadow: 0 20px 50px 0 rgba(0,0,0,0.2);
    background-color: white;
    width: 270px;
    padding: 6px 16px 10px 16px;

    label {
      color: ${colors.DARK};
      font-size: 8px;
      font-weight: 900;
      letter-spacing: 2px;
      line-height: 14px;
      text-transform: uppercase;
    }
  }
`;

export const DateRangeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3px;

  > div {
    width: 100%;
  }
`;

export const DateRangeIconWrapper = styled.div`
  display: none;
`;

export const SelectWrapper = styled.div`
  height: 45px;
  input {
    padding: 0 10px;
    margin-top: 3px;
    height: 40px;
  }
  .right {
    margin: -30px 10px;
  }
`;

export const SearchWrapper = styled.div`
  height: 45px;
  input {
    margin-top: 3px;
    height: 40px;
    padding: 0 0 0 30px!important;
  }
  .left-icon {
    margin: -30px 10px;
  }
`;

export const RowHyperlink = styled.a`
  text-transform: lowercase;
  &:hover {
    cursor: pointer;
    color: ${colors.MAIN_COLOR};
  }
`;

export const FilterActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 5px 0;

  button {
    width: 120px;
  }
`;

export const ClearButton = styled.button`
  color: ${colors.MAIN_COLOR};
  background-color: white;
`;